<template>
  <div class="h-100">
    <v-row class="h-100">
      <v-col class="h-100" cols="12">
        <v-row class="h-20">
          <v-col>Throughput :</v-col>
          <v-col class="text-right">{{ throughput.value }}</v-col>
        </v-row>
        <v-row class="h-30">
          <v-col class="h-85">
            <chart-throughput ref="throughput" :values="throughput.values" area-style="linearGradient" :x-axis-length="xAxisLength" :contextmenu="onContextmenuChart" />
          </v-col>
        </v-row>
        <v-row class="h-20">
          <v-col>Response Time :</v-col>
          <v-col class="text-right">
            <span class="mr-1">{{ responsetime.value }}</span>
            <span>ms</span>
          </v-col>
        </v-row>
        <v-row class="h-30">
          <v-col class="h-85">
            <chart-responsetime ref="responsetime" :values="responsetime.values" area-style="linearGradient" :x-axis-length="xAxisLength" :contextmenu="onContextmenuChart" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </v-row>
  </div>
</template>

<script>
import { format, parse } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import ChartThroughput from '../chart/LineSingle.vue';
import ChartResponsetime from '../chart/LineSingle.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    ChartThroughput,
    ChartResponsetime,
  },
  data() {
    return {
      xAxisLength: 20,
      throughput: {
        value: 0,
        values: [],
      },
      responsetime: {
        value: 0,
        values: [],
      },
      messageNames: ['rawJavaWorkload.3sec'],
      messageFields: ['stime', 'starttime', 'totStep', 'avgRespti'],
      buffers: [],
      contextmenuUrl: '/views/detailview/java/ut',
    };
  },
  methods: {
    wsBufferedDataHandler(key, responses) {
      const [response] = responses;
      const bound = response.length < this.xAxisLength ? response.length : this.xAxisLength;
      this.buffers.push(response.slice(response.length - bound));
      // 모든 메세지값이 취합되었을 경우
      if (this.buffers.length == this.messageNames.length) {
        const merged = [];
        this.buffers.forEach(responses => {
          responses.forEach(response => {
            response.data.forEach(d => {
              const ctime = zonedTimeToUtc(format(parse(d.starttime, 'yyyyMMddHHmmss', new Date()), 'yyyy-MM-dd HH:mm:ss.SSS'), { timeZone: this.$store.state.common.user.timeZoneId }).getTime();
              let target = merged.find(m => m.ctime == ctime);
              const data = {
                totStep: d.totStep ? parseInt(d.totStep) : 0,
                avgRespti: d.avgRespti ? parseFloat(d.avgRespti) : 0.0,
              };
              if (target) {
                target = {
                  ctime: target.ctime,
                  stime: target.stime,
                  data: target.data.push(data),
                };
              } else {
                merged.push({
                  ctime,
                  stime: ctime,
                  data: [data],
                });
              }
            });
          });
        });
        this.buffers = [];
        this.dataHandler(merged);
      }
    },
    wsDataHandler(key, response) {
      this.buffers.push(response);
      if (this.buffers.length == this.messageNames.length) {
        const merged = [];
        this.buffers.forEach(item => {
          item.forEach(d => {
            const ctime = parse(d.starttime, 'yyyyMMddHHmmss', new Date()).getTime();
            let target = merged.find(m => m.ctime == ctime);
            const data = {
              totStep: d.totStep ? parseInt(d.totStep) : 0,
              avgRespti: d.avgRespti ? parseFloat(d.avgRespti) : 0.0,
            };
            if (target) {
              target = {
                ctime: target.ctime,
                stime: target.stime,
                data: target.data.push(data),
              };
            } else {
              merged.push({
                ctime,
                stime: ctime,
                data: [data],
              });
            }
          });
        });
        this.buffers = [];
        this.dataHandler(merged);
      }
    },
    dataHandler(data) {
      const slice = data.length - this.xAxisLength;
      const d = slice > 0 ? data.slice(data.length - slice) : data;
      const handled = d.map(item => {
        const sum = item.data.reduce(
          (acc, d) => ({
            totalStep: acc.totalStep + parseInt(d.totStep),
            totalAverage: acc.totalAverage + parseFloat(d.avgRespti) * parseInt(d.totStep),
          }),
          {
            totalStep: 0,
            totalAverage: 0,
          },
        );
        return {
          ctime: item.ctime,
          stime: item.stime,
          throughput: sum.totalStep,
          responsetime: sum.totalStep ? Math.round(sum.totalAverage / sum.totalStep / 1000) : 0,
        };
      });
      const removeCount = this.throughput.values.length > handled.length ? handled.length : this.throughput.values.length;
      this.throughput.values.splice(0, removeCount);
      this.throughput.values = this.throughput.values.concat(handled.map(item => ({ name: parseInt(item.ctime), value: item.throughput })));
      this.throughput.value = this.throughput.values.length ? this.throughput.values[this.throughput.values.length - 1].value : 0;

      this.responsetime.values.splice(0, removeCount);
      this.responsetime.values = this.responsetime.values.concat(handled.map(item => ({ name: parseInt(item.ctime), value: item.responsetime })));
      this.responsetime.value = this.responsetime.values.length ? this.responsetime.values[this.responsetime.values.length - 1].value : 0;
    },
  },
  created() {
    this.$websocket.realtime.send({
      requests: this.messageNames.map(name => ({
        key: { name: name, sstmId: this.node.systemId, instId: this.node.instanceId, nodeId: this.node.id },
        fields: this.messageFields,
        handler: {
          buffer: this.wsBufferedDataHandler,
          every: this.wsDataHandler,
        },
      })),
    });
  },
};
</script>
